"use client";

import clsx from "clsx";
import { useState } from "react";
import generateVideoSource from "~/utils/generateVideoSource";
import Icon from "../Icon/Icon";
import CustomImage from "../CustomImage";
import CustomLink from "../CustomLink";
import VideoPopup from "../VideoPopup";
import { type AcfMediaItemConnectionEdge } from "~/__generated__/graphql";
import { cn } from "~/utils/cn";

export default function NewsCard({
  url,
  title,
  description,
  date,
  image,
  highlightedImage,
  imageSizes = "(min-width: 1280px) 22.21vw, (min-width: 1040px) calc(21.82vw - 63px), (min-width: 780px) calc(50vw - 40px), (min-width: 560px) 484px, calc(96.67vw - 38px)",
  itemType,
  // itemTags,
  isBigCard = false,
  className,
  isVideo = false,
  videoType = null,
  prismicVideo = null,
  videoId = "",
}: {
  url: string;
  title?: string | null;
  description?: string | null;
  date?: string | null;
  image?: AcfMediaItemConnectionEdge | null;
  highlightedImage?: AcfMediaItemConnectionEdge | null;
  imageSizes?: string;
  itemType?: string | null;
  // itemTags: string[];
  isBigCard?: boolean;
  className?: string;
  isVideo?: boolean;
  videoType?: string | null;
  prismicVideo?: string | null;
  videoId?: string;
}) {
  return (
    <CustomLink
      to={url}
      className={cn(
        "relative flex h-full w-full min-w-[17.5rem] flex-1 flex-col rounded-sm bg-white sm:max-w-[29.75rem]",
        className,
      )}
    >
      <span className="min-w-[6rem24 absolute left-0 top-0 flex h-12 items-center justify-center bg-blue px-6 py-3.5 text-white">
        {itemType}
      </span>
      {image && (
        <CustomImage
          data={image}
          className={cn(
            "h-full max-h-[13rem] min-h-[13rem] w-full object-cover",
            isBigCard && "max-h-[23rem] min-h-[23rem]",
          )}
          sizes={
            isBigCard
              ? "(min-width: 1280px) calc(66.63vw - 266px), (min-width: 1040px) calc(66.36vw - 135px), (min-width: 400px) calc(100vw - 48px), calc(65vw + 85px)"
              : "(min-width: 1960px) 476px, (min-width: 1280px) calc(29.7vw - 100px), (min-width: 1040px) calc(25vw + 20px), (min-width: 640px) calc(50vw - 40px), (min-width: 400px) calc(100vw - 48px), calc(65vw + 85px)"
          }
        />
      )}
      {(title || description || date) && (
        <div className="flex h-full flex-col gap-3.5 bg-black px-6 pb-8 pt-3">
          <div className="flex h-full flex-1 flex-col gap-3.5">
            {title && (
              <div className="w-full text-xl font-medium text-white">
                {title}
              </div>
            )}
            {/* {card?.articleFields?.description && ( */}
            {description && (
              <div className="mt-auto line-clamp-2 w-full text-base text-white">
                {description}
              </div>
            )}
          </div>
          {date && (
            <span className="text-blue">
              {new Date(date).toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          )}
        </div>
      )}
    </CustomLink>
  );
}
